<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

import moment from "moment";

import { mapGetters, mapActions } from "vuex";

export default {
  page: {
    title: "VISITS REPORT",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },

  components: {
    Layout,
    PageHeader,
  },

  data() {
    return {
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      filtered_array: [],
      filterstatus: false,
      filterreport: {
        date1: "",
        date2: moment(new Date()).format("YYYY-MM-DD"),
        age: "0",
        gender: "0",
        age_value: "",
        village: "",
      },
      title: "FACILITY VISITS REPORT",
      items: [
        {
          text: "FACILITY REPORTS",
          href: "#",
        },
        {
          text: "VISITS REPORT",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 15,
      pageOptions: [15, 25, 50, 100, 250, 500, 1000],
      filter: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: true,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        // {
        //   key: "branch",
        //   sortable: true,
        //   label: "BRANCH",
        // },
        {
          key: "patient_name",
          sortable: true,
          label: "NAME",
        },
        {
          key: "patient_code",
          sortable: true,
          label: "CODE",
        },
        {
          key: "patient_contact",
          sortable: true,
          label: "CONTACT",
        },
        {
          key: "gender",
          sortable: true,
          label: "Gender",
        },
        {
          key: "age",
          sortable: true,
          label: "Age",
        },
        {
          key: "village",
          sortable: true,
          label: "Address",
        },

        {
          key: "visitDate",
          sortable: true,
          label: "VISIT DATE",
        },
        {
          key: "services",
          sortable: true,
          label: "SERVICES",
        },
        {
          key: "turnardtime",
          sortable: true,
          label: "TAT",
        },
        {
          key: "payrecord",
          sortable: true,
          label: "PAID Amt",
        },
      ],
      data: {
        name: "",
        branch_id: "",
        type: "1",
        cost: "",
        price: "",
      },
      existingServices: [],
      nameError: "",
      priceError: "",
      costError: "",
      editData: {
        id: "",
        name: "",
        cost: "",
        price: "",
        branch_id: "",
      },
      deleteData: {
        id: "",
        name: "",
      },
      //   ============================= EXPORT ==============================
      json_fields: {
        BRANCH: "branch",
        NAME: "patient_name",
        CODE: "patient_code",
        CONATCT: "patient_contact",
        GENDER: "gender",
        AGE: "age",
        VILLAGE: "village",
        SERVICES: "completetests",
        VISIT_DATE: "visitDate",
        TURN_AROUND_TIME: "turnardtime",
        PAY_RECORD: "payrecord",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
    };
  },

  computed: {
    ...mapGetters("reports", [
      "FacilityVisitReport",
      "FacilityValueReportStatus",
    ]),
    ...mapGetters("patients", ["Villages"]),

    rows() {
      return this.filtered_array ? this.filtered_array.length : 1;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.filtered_array ? this.filtered_array.length : 1;
  },
  watch: {
    FacilityVisitReport(newValue) {
      if (newValue.length > 0) {
        this.fill_faclity_visit_report();
      }
    },
  },
  methods: {
    ...mapActions({
      FetchVisitReport: "reports/fetchFacilityVisitReport",
      FilterFacilityVisitReport: "reports/filterFacilityVisitReport",
      FetchVillages: "patients/fetchVillages",
    }),

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    fill_faclity_visit_report() {
      this.filtered_array = this.FacilityVisitReport
        ? this.FacilityVisitReport
        : [];
    },
    FilterRepo() {
      let startDate = this.filterreport.date1;
      let endDate = this.filterreport.date2;
      let gender = this.filterreport.gender;
      let age = this.filterreport.age;
      let age_value = this.filterreport.age_value;
      if (
        startDate != "" &&
        endDate != "" &&
        gender != "0" &&
        age == "<" &&
        age_value != ""
      ) {
        this.filtered_array = this.FacilityVisitReport.filter((pymts) => {
          return (
            pymts.filter_date >= startDate &&
            pymts.filter_date <= endDate &&
            pymts.gender_val == gender &&
            parseInt(pymts.age) < parseInt(age_value)
          );
        });
        alert("yoo");
      } else if (
        startDate != "" &&
        endDate != "" &&
        gender != "0" &&
        age == ">" &&
        age_value != ""
      ) {
        this.filtered_array = this.FacilityVisitReport.filter((pymts) => {
          return (
            pymts.filter_date >= startDate &&
            pymts.filter_date <= endDate &&
            pymts.gender_val == gender &&
            parseInt(pymts.age) > parseInt(age_value)
          );
        });
        alert("yoo");
      } else if (
        startDate != "" &&
        endDate != "" &&
        gender != "0" &&
        age == "==" &&
        age_value != ""
      ) {
        this.filtered_array = this.FacilityVisitReport.filter((pymts) => {
          return (
            pymts.filter_date >= startDate &&
            pymts.filter_date <= endDate &&
            pymts.gender_val == gender &&
            parseInt(pymts.age) == parseInt(age_value)
          );
        });
        alert("yoo");
      } else if (
        startDate != "" &&
        endDate != "" &&
        gender == "0" &&
        age == "0"
      ) {
        this.filtered_array = this.FacilityVisitReport.filter((pymts) => {
          return pymts.filter_date >= startDate && pymts.filter_date <= endDate;
        });
      } else if (
        startDate != "" &&
        endDate != "" &&
        gender != "0" &&
        age == "0"
      ) {
        this.filtered_array = this.FacilityVisitReport.filter((pymts) => {
          return (
            pymts.filter_date >= startDate &&
            pymts.filter_date <= endDate &&
            pymts.gender_val == gender
          );
        });
      } else if (
        startDate != "" &&
        endDate != "" &&
        gender == "0" &&
        age == ">" &&
        age_value != ""
      ) {
        this.filtered_array = this.FacilityVisitReport.filter((pymts) => {
          return (
            pymts.filter_date >= startDate &&
            pymts.filter_date <= endDate &&
            parseInt(pymts.age) > parseInt(age_value)
          );
        });
      } else if (
        startDate != "" &&
        endDate != "" &&
        gender == "0" &&
        age == "<" &&
        age_value != ""
      ) {
        this.filtered_array = this.FacilityVisitReport.filter((pymts) => {
          return (
            pymts.filter_date >= startDate &&
            pymts.filter_date <= endDate &&
            parseInt(pymts.age) < parseInt(age_value)
          );
        });
      } else if (
        startDate != "" &&
        endDate != "" &&
        gender == "0" &&
        age == "==" &&
        age_value != ""
      ) {
        this.filtered_array = this.FacilityVisitReport.filter((pymts) => {
          return (
            pymts.filter_date >= startDate &&
            pymts.filter_date <= endDate &&
            parseInt(pymts.age) == parseInt(age_value)
          );
        });
      } else if (startDate == "" && endDate != "") {
        this.filtered_array = this.FacilityVisitReport.filter((pymts) => {
          return pymts.filter_date <= endDate;
        });
      } else {
        this.filtered_array = this.FacilityVisitReport;
      }
    },
  },

  created() {
    this.FetchVisitReport();
    this.FetchVillages();
    this.fill_faclity_visit_report();
  },
};
</script>

<style scoped>
.loader-line {
  width: 200px;
  height: 3px;
  position: relative;
  overflow: hidden;
  background-color: #ddd;
  margin: 20px auto;
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  border-radius: 20px;
}

.loader-line:before {
  content: "";
  position: absolute;
  left: -50%;
  height: 3px;
  width: 40%;
  background-color: rgb(0, 4, 255);
  -webkit-animation: lineAnim 1s linear infinite;
  -moz-animation: lineAnim 1s linear infinite;
  animation: lineAnim 1s linear infinite;
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  border-radius: 20px;
}

@keyframes lineAnim {
  0% {
    left: -40%;
  }
  50% {
    left: 20%;
    width: 80%;
  }
  100% {
    left: 100%;
    width: 100%;
  }
}
</style>

<template>
  <Layout>
    <PageHeader :items="items" :title="title" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            {{ title }}<br />
            <div class="row">
              <div class="col-md-12">
                <div v-if="FacilityValueReportStatus" class="loader-line"></div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-2 form-group">
                <label>FROM</label>
                <input
                  @change="FilterRepo()"
                  v-model="filterreport.date1"
                  type="date"
                  class="form-control m-1"
                />
              </div>
              <div class="col-md-2 form-group">
                <label>TO</label>
                <input
                  @change="FilterRepo()"
                  v-model="filterreport.date2"
                  type="date"
                  class="form-control m-1"
                />
              </div>
              <div class="col-md-3 form-group" v-if="filterreport.age == 0">
                <label>GENDER</label>
                <select
                  @change="FilterRepo()"
                  v-model="filterreport.gender"
                  class="form-control m-1"
                >
                  <option value="0">All</option>
                  <option value="1">Male</option>
                  <option value="2">Female</option>
                </select>
              </div>
              <div class="col-md-2 form-group" v-else>
                <label>GENDER</label>
                <select
                  @change="FilterRepo()"
                  v-model="filterreport.gender"
                  class="form-control m-1"
                >
                  <option value="0">All</option>
                  <option value="1">Male</option>
                  <option value="2">Female</option>
                </select>
              </div>
              <div class="col-md-3 form-group" v-if="filterreport.age == 0">
                <label>AGE</label>
                <select
                  @change="FilterRepo()"
                  v-model="filterreport.age"
                  class="form-control m-1"
                >
                  <option value="0">All</option>
                  <option value=">">Greater than</option>
                  <option value="<">Less than</option>
                  <option value="=">Equal to</option>
                </select>
              </div>
              <div class="col-md-2 form-group" v-else>
                <label>AGE</label>
                <select
                  @change="FilterRepo()"
                  v-model="filterreport.age"
                  class="form-control m-1"
                >
                  <option value="0">All</option>
                  <option value=">">Greater than</option>
                  <option value="<">Less than</option>
                  <option value="==">Equal to</option>
                </select>
              </div>
              <div class="col-md-2 form-group" v-if="filterreport.age != 0">
                <label>VALUE</label>
                <input
                  @input="FilterRepo()"
                  v-model="filterreport.age_value"
                  type="text"
                  placeholder="Enter age"
                  class="form-control m-2"
                />
              </div>
              <div class="col-md-2 form-group">
                <button @click="FilterRepo()" class="btn btn-primary mb-6">
                  SEARCH
                </button>
              </div>
            </div>
            <!-- Table -->
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <download-excel
                  class="btn btn-primary mb-1"
                  :data="filtered_array"
                  :fields="json_fields"
                  :worksheet="'FACILITY VISITS REPORT ' + currentdate"
                  type="csv"
                  :name="'facilityvisitsreport' + currentdate + '.xls'"
                >
                  Export Excel <i class="fa fa-download"></i>
                </download-excel>
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      v-model="perPage"
                      :options="pageOptions"
                      class="form-select form-select-sm"
                      size="sm"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>

              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      class="form-control form-control-sm ms-2"
                      placeholder="Search..."
                      type="search"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>

            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                :current-page="currentPage"
                :fields="fields"
                :filter="filter"
                :filter-included-fields="filterOn"
                :items="filtered_array ? filtered_array : []"
                :per-page="perPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                bordered
                class="datatables"
                responsive="sm"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(dateTime)="data">
                  {{ data.item.dateCreated }}({{ data.item.time }})
                </template>
                <template #cell(age)="data">
                  {{ data.item.age }}
                  <span v-if="data.item.age_unit == 1">years</span>
                  <span v-else-if="data.item.age_unit == 2">Month</span>
                  <span v-else-if="data.item.age_unit == 3">Days</span>
                  <span v-else>--</span>
                </template>

                <template #cell(services)="data">
                  <span
                    v-for="(test, index) in data.item.labrequests
                      ? data.item.labrequests
                      : []"
                    :key="index"
                    ><span class="compla"
                      ><div>{{ test.test.name, }},</div></span
                    ></span
                  >
                  <span
                    v-for="(test, index) in data.item.completetests
                      ? data.item.completetests
                      : []"
                    :key="index"
                    ><span class="compla"
                      ><div>{{ test.test.name, }},</div></span
                    ></span
                  >
                  <span
                    v-for="(service, index) in data.item.patientservices"
                    :key="index"
                    ><span class="compla"
                      ><div>{{ service.service.name }},</div></span
                    ></span
                  >
                  <span
                    v-for="(prescription, index) in data.item.prescriptions"
                    :key="index"
                    ><span class="compla"
                      ><div>{{ prescription.item.serviceName }},</div></span
                    ></span
                  >
                </template>
              </b-table>
              <h3
                v-if="!this.FacilityVisitReport"
                class="text-primary text-center"
              >
                <b-spinner
                  class="m-0"
                  role="status"
                  variant="primary"
                ></b-spinner>
                Please wait...
              </h3>
              <div class="row">
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
